<template lang="html">
  <v-flex offset-md1 md10 mb-10>
    <v-layout row wrap pb-4>
      <order list v-for="(order, i) in filteredOrders" :value="order" :key="i" @details="details($event)"></order>
    </v-layout>
    <v-layout row wrap pb-5>
      <v-flex d-flex sm3>
        <v-layout row wrap>
          <v-flex sm6>
            <div class="v-subheader theme--light">itens por página</div>
          </v-flex>
          <v-flex sm6>
            <v-select
              single-line
              :value="itemsPerPage"
              bottom
              required
              v-model="ipp"
              v-bind:items="comboList"
              @change="refreshList"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm6>
        <v-layout row wrap justify-center>
          <p class="pt-3 pr-2 mb-0">{{pagingText}}</p>
        </v-layout>
      </v-flex>
      <v-flex d-flex sm3>
        <v-layout row wrap justify-end>
          <v-btn
              fab
              rounded
              outlined
              small
              @click.native="prev"
              v-show="currentPage > 1"
              >
                <v-icon light>arrow_back</v-icon>
          </v-btn>
          <v-btn
            fab
            rounded
            outlined
            small
            v-show="currentPage < totalPages"
            @click.native="next"
            >
              <v-icon light>arrow_forward</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import order from './order'
import moment from 'moment'
export default {
  name: 'orders-list',
  components: {
    'order': order
  },
  methods: {
    selectOrder (order) {
      this.$store.dispatch('selectOrder', order)
    },
    next () {
      this.$store.commit('nextPage')
      this.$store.dispatch(this.refreshMethod)
    },
    prev () {
      this.$store.commit('prevPage')
      this.$store.dispatch(this.refreshMethod)
    },
    refreshList () {
      this.$store.commit('changeItemsPerPage', this.ipp)
      this.$store.dispatch(this.refreshMethod)
    }
  },
  computed: {
    pagingText () {
      return `mostrando de ${((this.$store.getters.currentPage - 1) * this.$store.getters.itemsPerPage + 1)} a ${(this.$store.getters.currentPage * this.$store.getters.itemsPerPage)} de ${this.$store.getters.totalItems}`
    },
    filteredOrders () {
      if (this.searchOrders === '') {
        return this.tabOrder
      } else {
        return this.tabOrder.filter(elem => {
          let exp = new RegExp(this.searchOrders.trim(), 'i')
          let itens = elem.itens.map(elem => elem.name).join('')
          let searchItem = elem.register +
            elem.condominium.name +
            elem.condominium.address +
            elem.condominium.addressNumber +
            elem.condominium.neighborhood +
            elem.condominium.city +
            elem.condominium.state +
            elem.condominium.administrator +
            itens +
            moment(elem.date).format('DD/MM/YYYY')
          return exp.test(searchItem)
        })
      }
    },
    searchOrders () {
      return this.$store.getters.searchOrders
    },
    currentPage () {
      return this.$store.getters.currentPage
    },
    itemsPerPage () {
      return this.$store.getters.itemsPerPage
    },
    totalPages () {
      return this.$store.getters.totalPages
    }
  },
  data () {
    return {
      comboList: [6, 12, 18, 24, 30],
      ipp: 12
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3b19aeb7